const Footer = ({ t }) => (
  <footer
    data-testid="site-footer"
    className="relative z-10 border-t border-white/5 px-6 py-10 text-center"
  >
    <p className="font-serif text-base font-light italic tracking-widest text-white/50">
      {t.footer}
    </p>
  </footer>
);

export default Footer;
